import { useEffect, useState, useCallback, useRef } from 'react';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import fetchWithToken from '../../services';

const LinkIdInput = ({ originalLinkId, linkId, setLinkId, isLinkIdValid, setIsLinkIdValid }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [userChange, setUserChange] = useState(false);
    const MAX_LENGTH = 20;

    const checkLinkId = useCallback(async (linkId) => {
        console.log('running checkLinkId');
        if (!linkId) {
            setIsLinkIdValid(false);
            setErrorMessage('Link ID cannot be empty');
            return;
        }

        // Check if linkId contains only valid characters
        const validPattern = /^[a-z0-9-]+$/;
        if (!validPattern.test(linkId)) {
            setIsLinkIdValid(false);
            setErrorMessage('Link ID can only contain lowercase letters, numbers, and hyphens');
            return;
        }

        try {
            const response = await fetchWithToken('/check-link-unique', {
                method: 'POST',
                body: JSON.stringify({ linkId }),
            });

            const data = await response.json();

            if (data.isUnique) {
                setIsLinkIdValid(true);
                setErrorMessage('');
            } else {
                setIsLinkIdValid(false);
                setErrorMessage('This link ID is already taken');
            }
        } catch (error) {
            console.error('Error checking link ID:', error);
            setIsLinkIdValid(false);
            setErrorMessage('Error checking link ID');
        }
    }, []);

    // Debounce function for input
    useEffect(() => {
        // Skip the effect on initial mount
        if (!userChange) {
            return;
        }

        const timer = setTimeout(() => {
            if (linkId) {
                checkLinkId(linkId);
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [linkId, checkLinkId]);

    const handleChange = (event) => {
        const value = event.target.value.toLowerCase().slice(0, MAX_LENGTH);
        setUserChange(true);
        setLinkId(value);
        setIsLinkIdValid(null);
    };

    return (
        <div className="flex flex-col align-left space-y-5 w-full max-w-lg">
            <div className="relative flex items-center">
                <p className="font-semibold mr-1">tipl.co/</p>
                <input
                    type="text"
                    name="linkId"
                    value={linkId}
                    onChange={handleChange}
                    maxLength={MAX_LENGTH}
                    className={`w-12 flex-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 text-black text-left ${isLinkIdValid === true ? 'border-green-500 focus:ring-green-500' :
                        isLinkIdValid === false ? 'border-red-500 focus:ring-red-500' :
                            'border-gray-300 focus:ring-blue-500'
                        }`}
                />
                {isLinkIdValid === true && (
                    <FaCheckCircle className="h-5 w-5 text-green-500 absolute top-1/2 right-2 transform -translate-y-1/2" />
                )}
                {isLinkIdValid === false && (
                    <FaExclamationCircle className="h-5 w-5 text-red-500 absolute top-1/2 right-2 transform -translate-y-1/2" />
                )}
            </div>
            {errorMessage && (
                <p className="text-red-500 text-sm">{errorMessage}</p>
            )}
            {/* <p className="text-gray-500 text-xs text-right w-full">{linkId.length}/{MAX_LENGTH}</p> */}
        </div>
    );
};

export default LinkIdInput;
